import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-scroll';
import addComma from 'utils/add-comma';

class AnalyticsSummary extends Component {
  render() {
    var { summary, isSso } = this.props;
    let element = document.querySelector('.navigation-container');
    let offset = 0 || (element && -element.clientHeight);
    return (
      <div className="summary">
        <div className="summary-item">
          <Link className="item-count" offset={offset} to="pageViews" smooth duration={500}>
            {addComma(summary.page_views)}
          </Link>
          <div className="item-description">Pageviews via OpenWeb</div>
        </div>
        <div className="summary-item">
          <Link className="item-count" offset={offset} to="comments" smooth duration={500}>
            {addComma(summary.comments + summary.replies)}
          </Link>
          <div className="item-description">Comments and Replies posted</div>
        </div>
        <div className="summary-item">
          <Link className="item-count" offset={offset} to="ranks" smooth duration={500}>
            {addComma(summary.likes + summary.dislikes)}
          </Link>
          <div className="item-description">Total likes</div>
        </div>
        {!isSso ? (
          <div className="summary-item">
            <Link className="item-count" offset={offset} to="registrations" smooth duration={500}>
              {addComma(summary.registrations)}
            </Link>
            <div className="item-description">Total Registrations</div>
          </div>
        ) : null}
      </div>
    );
  }
}
AnalyticsSummary.displayName = 'AnalyticsSummary';

AnalyticsSummary.propTypes = {
  summary: PropTypes.object.isRequired
};

export default AnalyticsSummary;
